/**
 * @module updateActionEndpointRequestState
 */

import { mutatorAction } from 'satcheljs';
import actionEndpointStore from '../store/actionEndpointStore';
import { ActionEndpointRequestState } from '../store/schema/actionEndpointCache';

/**
 * @MutatorAction
 * A mutator to update the service request state for action endpoint.
 */
const updateActionEndpointRequestState = mutatorAction(
    'updateActionEndpointRequestState',
    (state: ActionEndpointRequestState) => {
        actionEndpointStore.requestState = state;
    }
);

export default updateActionEndpointRequestState;
